import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import { Popover } from 'antd';
import moment from 'moment';

import { PopoverContainer, WidgetBox } from './styles';
import { Bar } from 'react-chartjs-2';


type PropType = {
  data: any;
  title: string;
  id: any;
  unit: any;
  widgetID: string;
  deleteWidgetByIndex: Function;
  editWidget?: Function;
  isPreview?: boolean;
  widget?: any;
  duplicateWidget: Function;
}

const GoalsChart = (props: PropType) => {
  const popoverContent = () => {
    return (
      <PopoverContainer>
        <div style={{ display: 'flex' }} className="popover-row" onClick={() => props.editWidget(props)} >
          <div className="icon">
            <FontAwesomeIcon icon={'edit'} />
          </div>
          <div className="text">
            <p>{I18n.l('common.edit')}</p>
          </div>
        </div>
  
        <div style={{ display: 'flex' }} className="popover-row" onClick={() => props.duplicateWidget()}>
          <div className="icon">
            <FontAwesomeIcon icon={'clone'} />
          </div>
          <div className="text">
            <p>{I18n.l('common.duplicate')}</p>
          </div>
        </div>
  
        <div style={{ display: 'flex' }} className="popover-row" onClick={() => props.deleteWidgetByIndex(props.id, props.widgetID)}>
          <div className="icon">
            <FontAwesomeIcon icon={'trash'} />
          </div>
          <div className="text">
            <p>{I18n.l('common.delete')}</p>
          </div>
        </div>
      </PopoverContainer>
    )
  }

  const handleDataChart = (data: any) => {
    if (data.executed) {
      moment.locale(localStorage.locale)
      const labels = Array(12).fill('d').map((e: any, i: number) => moment().month(i).format('MMM'))
      const executedByMonth = labels.map((month, index) => {
        return data.executed.filter((exe : any) => exe.month === index+1 && exe.year === data.year).length
      })
      const dataChart = executedByMonth.map((exec: any, index: number) => {
        if(data.audited){
          if (data.audited.hasOwnProperty(`${index + 1}-${data.year}`)) {
            return Number.parseFloat(exec / data.audited[`${index + 1}-${data.year}`] * 12).toFixed(2)
          } else {
            return Number.parseFloat(exec / data.audited[Object.keys(data.audited)[0]] * 12).toFixed(2)
          }
        }else {
          return Number.parseFloat(exec / data.allAudited * 12).toFixed(2)
        }
      })
      return {
        labels,
        datasets: [{
          data: dataChart,
          label: I18n.l('wigdets.goals.rate'),
          backgroundColor: '#77DEA0',
          borderColor: '#77DEA0',
          pointHoverBackgroundColor: '#77DEA0',
          pointRadius: 4,
          lineTension: 0.3,
          fill: false
        }]
      }
    }
    return null
  }

  return (
    <WidgetBox className={`-barChart ${props.isPreview ? "-preview" : ''}`}>
      <div className="up">
        <div className="title">
          {props.title}
        </div>
        {!props.isPreview &&
          <div className="edit no-padding">
            <Popover
              placement='bottom'
              trigger="hover"
              content={popoverContent()}
            >
              <FontAwesomeIcon icon={"cog"} />
            </Popover>
          </div>
        }
      </div>
      <div className='bottom canvasChart'>
        <Bar data={handleDataChart(props.data) || []} />
      </div>
    </WidgetBox>
  )
}

export default GoalsChart
